module.exports = __webpack_public_path__ + "img/loader.34a0be18.gif";